export default __webpack_public_path__ + "static/media/pen.2acd845b.png";